import { ref, computed, onMounted } from "vue";

interface MSWindow extends Window {
	MSStream?: boolean;
}

export function useDevicePlatform() {
	const deviceOS = ref<"iOS" | "Android" | "unknown">("unknown");

	const isIOS = computed(() => deviceOS.value === "iOS");
	const isAndroid = computed(() => deviceOS.value === "Android");
	const isMobile = computed(() => isIOS.value || isAndroid.value);

	onMounted(() => {
		// Properly type userAgent
		const userAgent = navigator.userAgent || "";
		const msWindow = window as MSWindow;

		// Check for iOS
		if (/iPad|iPhone|iPod/.test(userAgent) && !msWindow.MSStream) {
			deviceOS.value = "iOS";
			return;
		}

		// Check for Android
		if (/android/i.test(userAgent)) {
			deviceOS.value = "Android";
			return;
		}

		// For modern iOS detection
		if (
			/Safari/.test(userAgent) &&
			!msWindow.MSStream &&
			navigator.platform &&
			/iPad|iPhone|iPod/.test(navigator.platform)
		) {
			deviceOS.value = "iOS";
			return;
		}

		// Additional check for newer iOS devices
		const platform = navigator.platform || "";
		if (
			"maxTouchPoints" in navigator &&
			navigator.maxTouchPoints > 0 &&
			/MacIntel/.test(platform)
		) {
			deviceOS.value = "iOS";
			return;
		}
	});

	return {
		deviceOS,
		isIOS,
		isAndroid,
		isMobile,
	};
}
